export function getIDSuffix(id: string, suffix: string) {
    return id + '-' + suffix;
}

export const SVGNS = 'http://www.w3.org/2000/svg';